<template>
  <div id='Foot'>

    <div class='footBox'>
      <div  class="footLogo">
           <img src="../assets/logo.png">
      </div>
     
      <div class='footBottom'>
          <div class='footTxt'>
              <div>© 2019 成都小橘袋健康科技有限公司 NUTRIPACKS LLC. All Rights Reserved</div>
              <div><a href="http://beian.miit.gov.cn/">蜀ICP备18038614号-1 网站编号：477229</a></div>
          </div>
           <div class='footRouter'>
              <router-link :to="item.name"  v-for="item in routerFoot">
                      <div >{{item.title}}</div>
              </router-link>
           </div>
      </div>
       
        
    </div>
  </div>
</template>

<script>
export default {
  name: 'Foot',
  data:function () {
    return{
      routerFoot:[
              {title:"条款及条件",name:"/clause"},
              {title:"隐私政策",name:"/privacy"},
              ],
   }
  },
}
</script>  

<style>
#Foot{
  width: 100%;
  height: 198px;
  background:rgba(249,249,250,1);
  
}
.footBox{
  width: 85vw;
  margin:0 auto;

}
.footLogo{
  padding: 49px 0 22px;
  /*border-bottom: 1px solid rgba(216,216,216,1);*/
}
.footLogo img{
    width: 160px;
    height:20px;
    display: block;
  }
.footBottom{
  display: flex;
  justify-content: space-between;
  }
.footTxt{
    font-size:14px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(120,120,120,1);
    line-height:28px;
    text-align:left;
    width: 50vw;
  }
  .footTxt div{
    line-height:28px;
  }
.footRouter{
  display: flex;
}
.footRouter a{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(120,120,120,1);
  line-height:20px;
  margin-right: 1vw;
}
.footRouter a:hover{
  text-decoration:none;
  color:rgba(120,120,120,1);
}
a:link{
text-decoration:none;
}
a:visited{
text-decoration:none;
}
a:hover{
text-decoration:none;
}
a:active{
text-decoration:none;
}
</style>